<select
  [compareWith]="compareReferencias"
  bootstrapSelect
  [(ngModel)]="selectedReferencias"
  [class]="customClasses"
  [title]="customTitle"
  [maxOptions]="maxOptions"
  [disabled]="disabled"
  multiple
>
  <option
    *ngFor="let referencia of referencias"
    [ngValue]="referencia"
    id="{{ referencia.Id }}"
  >
    {{ referencia.Nombre }}
  </option>
</select>
